import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TopLevelLayers } from 'src/app/menu/view-menu/top-level-layers';
import { ExportProcessingToolComponent } from '../export-processing-tool/export-processing-tool.component';
import { ExportComponent } from '../export/export.component';

@Injectable({
  providedIn: 'root'
})
export class ExportControlService {

  constructor(private modalService: BsModalService) { }

  showMesssageModal(entity:string, options : string[]){
    const bsModalRef : BsModalRef = this.modalService.show(ExportComponent);
    bsModalRef.content.entity = entity;
    bsModalRef.content.optionsToDisplay = options;
  }

  showExportProcessingToolModal(processingToolLayer: TopLevelLayers){
    const bsModalRef : BsModalRef = this.modalService.show(ExportProcessingToolComponent);
    bsModalRef.content.model = ExportProcessingToolComponent.createModel(processingToolLayer);
    bsModalRef.content.conditions = ExportProcessingToolComponent.pushValues(processingToolLayer);
  }
}
